import { Flow } from 'signup-constants/Flow';
import styled from 'styled-components';
import { Step } from 'signup-constants/Step';
import { AnimatedStep } from 'signup-components/styles/Animations.styles';
export const ExtendedAnimatedStep = styled(AnimatedStep).withConfig({
  displayName: "Animationsstyles__ExtendedAnimatedStep",
  componentId: "v2wyk-0"
})(["", ""], props => props.$flowKey === Flow.FbCrm && props.$currentStep === Step.LandingPage && `padding-top: 40px;`);